// extracted by mini-css-extract-plugin
export default {"container":"cashouts_container__GNqNE","title":"cashouts_title__8sERU"};